// create a GuxTag with a label Preview
import { GuxTag, GuxTooltip } from "genesys-spark-components-react";
import strings from "./PreviewTag.strings";
import { useStrings } from "features/i18n/useStrings";
import { FeatureGate } from "features/featureToggles/FeatureGate";
import FeatureToggle from "enums/FeatureToggle";
import TagAccent from "enums/TagAccent";

function PreviewTag({
    disabled = false,
    showTooltip,
}: {
    disabled: boolean;
    showTooltip: boolean;
}) {
    const t = useStrings(strings);

    return (
        <FeatureGate
            flag={FeatureToggle.USE_OUTER_LIMITS}
            showWhenEnabled={false}
        >
            <div>
                <GuxTag
                    accent={TagAccent.FLARE}
                    emphasis="subtle"
                    data-testid="ai-scoring-preview"
                    disabled={disabled}
                    aria-disabled={disabled}
                >
                    <span>{t.label}</span>
                </GuxTag>
                {showTooltip && <GuxTooltip>{t.tooltip}</GuxTooltip>}
            </div>
        </FeatureGate>
    );
}

export default PreviewTag;
